import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { ShoppingBag, ExternalLink, Trash2 } from "lucide-react";
import { useIsEmbedded } from "@/lib/embed";

export const MiniCart = ({ open, onOpenChange, items, onRemove }) => {
  const embedded = useIsEmbedded();
  const total = items.reduce((s, i) => s + (i.price || 0), 0);
  const checkoutUrl = items.length
    ? `https://clubdinksupply.com/cart/${items.map((i) => `${i.variant_id}:1`).join(",")}`
    : "#";

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-[420px]" data-testid="mini-cart">
        <SheetHeader>
          <SheetTitle style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <ShoppingBag size={18} /> Your cart
          </SheetTitle>
        </SheetHeader>

        <div style={{ padding: "20px 0", display: "grid", gap: 10 }}>
          {items.length === 0 && (
            <div className="cd-sub" data-testid="mini-cart-empty">
              Nothing here yet. Add a paddle to see it appear.
            </div>
          )}
          {items.map((it, idx) => (
            <div key={idx} className="cd-cart-item" data-testid={`mini-cart-item-${it.variant_id}`}>
              {it.image && <img src={it.image} alt={it.title} />}
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 14, fontWeight: 600, lineHeight: 1.3 }}>{it.title}</div>
                <div className="cd-micro" style={{ marginTop: 2 }}>{it.variant_title || "Default"}</div>
                <div className="cd-money" style={{ fontSize: 14, marginTop: 4 }}>${it.price?.toFixed(2)}</div>
              </div>
              <button
                className="cd-btn-ghost"
                onClick={() => onRemove(idx)}
                data-testid={`mini-cart-remove-${it.variant_id}`}
                aria-label="Remove"
              >
                <Trash2 size={16} />
              </button>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <div style={{ borderTop: "1px solid var(--cd-border)", paddingTop: 16 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
              <span className="cd-sub">Subtotal</span>
              <span className="cd-money">${total.toFixed(2)}</span>
            </div>
            <a
              href={checkoutUrl}
              target={embedded ? "_top" : "_blank"}
              rel="noreferrer"
              className="cd-btn-primary"
              style={{ width: "100%", textDecoration: "none" }}
              data-testid="mini-cart-checkout-btn"
            >
              Checkout on Club Dink <ExternalLink size={16} />
            </a>
            <div className="cd-micro" style={{ textAlign: "center", marginTop: 8 }}>
              Opens a secure Shopify cart with your paddle already added.
            </div>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};
